<template>
	<div class="height-100dvh">
		<div id="hideinlaptop" class="mob-back-header d-flex align-items-center">
			<img
				class="mr-3"
				src="../../assets/mobile/assprog/mobileBackArrow.svg"
				alt=""
				@click="gotoProfile()"
			/>
			Become a Panelist
		</div>
		<main class="verify-main-container w-100">
			<div id="hideinmobile" class="cand-header d-flex mb-2">
				<img
					class="mr-3 d-flex pointer"
					src="../../assets/img/homepage/back-arrow-blue.svg"
					alt=""
					@click="gotoProfile()"
				/>
				Become a panelist
			</div>
			<div class="verify-down-cont">
				<section class="verify-left-cont">
					<h2 class="fam-mont text-blue fw-M verify-fs-32 mb-0">
						Verify Your Account
					</h2>
					<h5 class="fam-lato text-darkgrey fw-R verify-fs-20 z-ind-2">
						To maintain a high-quality panel, we require account verification.
						Provide your LinkedIn profile link to confirm your professional
						identity. Be part of a trusted network assessing candidates.
					</h5>
					<div class="verify-white-box">
						<article>
							<img
								src="../../assets/newdesign/BecomePanelist/earnMoney.svg"
								alt=""
							/>
						</article>
						<article>
							<div class="text-headtext fam-mont fs-14 fw-M">
								Earn Money as a Panelist
							</div>
							<div class="text-8cgrey fs-13 fam-lato fw-M">
								Get paid for your expertise by conducting interviews and
								assessing top talents.
							</div>
						</article>
					</div>
					<div class="verify-white-box">
						<article>
							<img
								src="../../assets/newdesign/BecomePanelist/excluCom.svg"
								alt=""
							/>
						</article>
						<article>
							<div class="text-headtext fam-mont fs-14 fw-M">
								Join Our Expert Community
							</div>
							<div class="text-8cgrey fs-13 fam-lato fw-M double-line-truncate">
								Connect with industry professionals and shape the future of
								hiring.
							</div>
						</article>
					</div>
					<div
						class="verify-linkedin verify-mt-4 position-relative"
						:class="{ 'verify-red-border': isInvalid || isEmpty }"
					>
						<div class="verify-linkedin-img">
							<img
								src="../../assets/newdesign/BecomePanelist/linkedin.svg"
								alt=""
							/>
						</div>
						<div class="w-90">
							<b-form-input
								placeholder="https://www.linkedin.com/"
								v-model="linkedInUrl"
								@keyup.enter="goToExpertise()"
							></b-form-input>
						</div>
						<div
							v-if="isEmpty || isInvalid"
							class="d-flex align-items-center fam-lato fw-R fs-12 text-red gap-2 link-alert-pos"
						>
							<img
								src="../../assets/newdesign/BecomePanelist/linkedinAlert.svg"
								alt=""
							/>
							<span v-if="isEmpty">This field is required.</span>
							<span v-else-if="isInvalid">Link does not exist/invalid.</span>
						</div>
					</div>

					<b-button
						id="hideinmobile"
						@click="goToExpertise()"
						class="candash-addBtn mt-4"
						>Verify Me</b-button
					>
				</section>
				<section class="verify-back-img-size">
					<img
						class="h-100 w-100"
						src="../../assets/newdesign/BecomePanelist/verify-back.svg"
						alt=""
					/>
				</section>
			</div>
			<footer id="hideinlaptop">
				<b-button @click="goToExpertise()" class="candash-addBtn w-100"
					>Verify Me</b-button
				>
			</footer>
		</main>
	</div>
</template>

<script>
import mobHeader from "@/components/fixedcomponents/mobileHeader.vue";
import { getPanelNotification, getCvsDetails } from "@/utils/apiFunctions";
export default {
	components: {
		mobHeader,
	},
	data() {
		return {
			linkedInUrl: null,
			linkedinRegex:
				/^(https?:\/\/)?(www\.)?linkedin\.com\/(in\/[a-zA-Z0-9\-]+|pub\/[a-zA-Z0-9\-]+\/[0-9]+\/[0-9]+\/[0-9]+)\/?$/,
			isInvalid: false,
			isEmpty: false,
		};
	},
	created() {
		this.fetchPanelStat();
	},
	methods: {
		async goToExpertise() {
			try {
				this.isEmpty = !this.linkedInUrl;
				this.isInvalid =
					!this.linkedinRegex.test(this.linkedInUrl) && !!this.linkedInUrl;
				if (!this.isInvalid && !this.isEmpty) {
					// let payload = {
					// 	link: this.linkedInUrl,
					// };
					// const res = await postLinkedinUrl(payload);
					// if (res.status == 200) {
					this.$router.push({
						name: "ChooseExpertise",
						query: { linkedInUrl: this.linkedInUrl }, // Passing the URL as query param
					});
					// }
				}
			} catch (error) {
				console.log(error);
			}
		},
		async fetchPanelStat() {
			try {
				const res = await getCvsDetails();
				if (res.status == 200) {
					this.$router.push({
						name: "ApplicationResult",
					});
				}
			} catch (error) {
				console.log(error);
			}
		},
		gotoProfile() {
			this.$router.push({
				name: "Homepage",
			});
		},
	},
};
</script>

<style>
.verify-main-container {
	background-color: #e9ecef;
	height: calc(100vh - 60px);
	padding: 15px 15px 15px 75px;
	top: 60px;
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
}
.verify-down-cont {
	height: calc(100vh - 100px);
	overflow: auto;
	border-radius: 8px;
	background-color: #f0f5ff;
	border: 1px solid #8c8c8c54;
	box-shadow: 0px 4px 8px 0px #0000002b;
	display: flex;
	justify-content: space-between;
	max-width: 1825px;
}

.verify-back-img-size {
	height: calc(100vh - 151px);
}
.verify-left-cont {
	padding: 30px;
	width: 45%;
	display: flex;
	flex-direction: column;
	gap: 20px;
	height: 100%;
	overflow: auto;
}
.verify-left-cont::-webkit-scrollbar-track {
	background: transparent;
}
.verify-white-box {
	padding: 12px 18px;
	display: flex;
	align-items: center;
	gap: 20px;
	border-radius: 8px;
	background: linear-gradient(270deg, #f0f5ff 0%, #ffffff 100%);
}
.verify-red-border .verify-linkedin-img {
	border: 2px solid #eb0002;
	border-right: none;
}
.verify-red-border .form-control {
	border-top: 2px solid #eb0002 !important;
	border-bottom: 2px solid #eb0002 !important;
	border-right: 2px solid #eb0002 !important;
	border-left: none;
}
.link-alert-pos {
	position: absolute;
	top: 45px;
}
.verify-linkedin {
	display: flex;
	border-radius: 10px;
}
.verify-linkedin .form-control {
	border: none;
	width: 100%;
	height: 40px;
	border: 2px solid #8c8c8c4d;
	border-left: none;
	padding: 6px 10px 7px 10px;
	border-radius: 0px 8px 8px 0px;
}
.verify-linkedin .form-control:focus {
	box-shadow: none;
}

.verify-fs-32 {
	font-size: 32px;
}

.verify-fs-20 {
	font-size: 20px;
}
.verify-mt-4 {
	margin-top: 15px;
}
@media only screen and (max-width: 1028px) {
	.verify-main-container {
		background-color: #e9ecef;
		height: calc(
			100dvh - (60px + env(safe-area-inset-top) + env(safe-area-inset-bottom))
		);
		padding: 0px;
		overflow: auto;
		/* position: fixed; */
		top: unset;
		display: block;
	}
	.verify-left-cont {
		padding: 30px 15px 15px 15px;
		width: 100%;
	}
	.verify-down-cont {
		height: 92%;
		position: relative;
		border-radius: 0px;
		box-shadow: none;
		background-color: #e9ecef;
	}
	.verify-fs-32 {
		font-size: 20px;
	}
	.verify-fs-20 {
		font-size: 14px;
		width: 65%;
	}
	.verify-main-container footer {
		background-color: #f9fafb;
		height: 8%;
		padding-inline: 15px;
		display: flex;
		align-items: center;
	}
	.verify-back-img-size {
		height: unset;
		width: 40%;
		position: absolute;
		top: 0px;
		right: 0px;
		z-index: 0;
	}
	.verify-mt-4 {
		margin-top: 10px;
	}
}
</style>
